export default {
  getSophiaText: (state) => state.sophiaText,
};
